module.exports = __webpack_public_path__ + "static/media/current-time.7d7688fa.pdf";